module.exports = __webpack_public_path__ + "img/158-egypt.70247bdc.svg";